/** @jsxImportSource theme-ui */
import { Box } from "theme-ui";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";

import { useTranslation } from "hooks";
import { displayReviewModal } from "store/app/appSlice";
import {
  selectHasAllRequiredValues,
  selectShowAddToOrderButton,
} from "store/app";
import { Button, _ImageBadges } from "components";
import {
  ShareIcon,
  PrintIcon,
  DownloadIcon,
  MapPinIcon,
  PlusIcon,
} from "components/icons";
import * as styles from "./Product.styles";

export default function AddToOrder({
  dispatchDisplaySaveModal,
  dispatchDisplayShareModal,
  gameFitDealerLink,
  hidePrintButton = true,
  hideSaveButton = true,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showAddToOrderButton = useSelector(selectShowAddToOrderButton);
  const hasAllRequiredValues = useSelector(selectHasAllRequiredValues);

  const dispatchDisplayReviewModal = () => dispatch(displayReviewModal());

  return (
    <motion.div
      sx={styles.addToOrderContainer}
      initial={{
        opacity: 0,
        x: "100%",
      }}
      animate={{
        x: "0%",
        opacity: 1,
        transition: {
          duration: 0.3,
        },
      }}
    >
      {showAddToOrderButton && (
        <Button
          isRound
          iconBefore={<PlusIcon />}
          size="large"
          onClick={dispatchDisplayReviewModal}
          disabled={!hasAllRequiredValues}
          sx={styles.addToOrderButton}
        >
          {t("Add To Order")}
        </Button>
      )}

      <Box sx={styles.shareButtonsContainer}>
        {!hidePrintButton && (
          <Button
            iconBefore={<PrintIcon />}
            aria-label={t("print")}
            theme="light"
            isRound
            sx={styles.iconButton}
          />
        )}

        <Button
          iconBefore={<ShareIcon />}
          aria-label={t("share")}
          theme="light"
          isRound
          sx={styles.iconButton}
          onClick={dispatchDisplayShareModal}
          disabled={!hasAllRequiredValues}
        />

        {!hideSaveButton && (
          <Button
            iconBefore={<DownloadIcon />}
            aria-label={t("download")}
            theme="light"
            isRound
            sx={styles.iconButton}
            onClick={dispatchDisplaySaveModal}
          />
        )}
      </Box>

      {gameFitDealerLink && (
        <Button
          href={gameFitDealerLink.href}
          iconBefore={<MapPinIcon />}
          theme="light"
          isRound
          sx={styles.fixExpertDealerLocationButton}
          target="_blank"
          rel="noopener noreferrer"
        >
          {gameFitDealerLink.label}
        </Button>
      )}
    </motion.div>
  );
}
